const covidData = [
  {
    id: 1,
    country: 'Ethiopia',
    todayConfirmed: 1245,
    todayDeath: 18,
    todayNewConfirmed: 245,
    todayNewDeaths: 4,
    todayNewOpenCases: 200,
    todayNewRecovered: 41,
    todayOpenCases: 1200,
    todayRecovered: 25,
  },
  {
    id: 2,
    country: 'Kenya',
    todayConfirmed: 178,
    todayDeath: 5,
    todayNewConfirmed: 48,
    todayNewDeaths: 2,
    todayNewOpenCases: 30,
    todayNewRecovered: 16,
    todayOpenCases: 140,
    todayRecovered: 33,
  },
  {
    id: 3,
    country: 'Nigeria',
    todayConfirmed: 356,
    todayDeath: 8,
    todayNewConfirmed: 62,
    todayNewDeaths: 1,
    todayNewOpenCases: 40,
    todayNewRecovered: 21,
    todayOpenCases: 300,
    todayRecovered: 48,
  },
  {
    id: 4,
    country: 'South Africa',
    todayConfirmed: 945,
    todayDeath: 12,
    todayNewConfirmed: 125,
    todayNewDeaths: 2,
    todayNewOpenCases: 70,
    todayNewRecovered: 43,
    todayOpenCases: 800,
    todayRecovered: 133,
  },
  {
    id: 5,
    country: 'Tanzania',
    todayConfirmed: 32,
    todayDeath: 1,
    todayNewConfirmed: 5,
    todayNewDeaths: 0,
    todayNewOpenCases: 2,
    todayNewRecovered: 3,
    todayOpenCases: 25,
    todayRecovered: 6,
  },
  {
    id: 6,
    country: 'Ghana',
    todayConfirmed: 216,
    todayDeath: 4,
    todayNewConfirmed: 36,
    todayNewDeaths: 1,
    todayNewOpenCases: 25,
    todayNewRecovered: 10,
    todayOpenCases: 180,
    todayRecovered: 32,
  },
  {
    id: 7,
    country: 'Uganda',
    todayConfirmed: 79,
    todayDeath: 2,
    todayNewConfirmed: 19,
    todayNewDeaths: 0,
    todayNewOpenCases: 10,
    todayNewRecovered: 9,
    todayOpenCases: 65,
    todayRecovered: 12,
  },
  {
    id: 8,
    country: 'Egypt',
    todayConfirmed: 520,
    todayDeath: 15,
    todayNewConfirmed: 95,
    todayNewDeaths: 3,
    todayNewOpenCases: 70,
    todayNewRecovered: 22,
    todayOpenCases: 450,
    todayRecovered: 55,
  },
  {
    id: 9,
    country: 'Morocco',
    todayConfirmed: 265,
    todayDeath: 3,
    todayNewConfirmed: 55,
    todayNewDeaths: 0,
    todayNewOpenCases: 35,
    todayNewRecovered: 20,
    todayOpenCases: 220,
    todayRecovered: 42,
  },
  {
    id: 10,
    country: 'Algeria',
    todayConfirmed: 130,
    todayDeath: 3,
    todayNewConfirmed: 25,
    todayNewDeaths: 0,
    todayNewOpenCases: 15,
    todayNewRecovered: 7,
    todayOpenCases: 110,
    todayRecovered: 20,
  },
  {
    id: 11,
    country: 'Sudan',
    todayConfirmed: 32,
    todayDeath: 1,
    todayNewConfirmed: 5,
    todayNewDeaths: 0,
    todayNewOpenCases: 2,
    todayNewRecovered: 3,
    todayOpenCases: 25,
    todayRecovered: 6,
  },
  {
    id: 12,
    country: 'Tunisia',
    todayConfirmed: 220,
    todayDeath: 6,
    todayNewConfirmed: 32,
    todayNewDeaths: 0,
    todayNewOpenCases: 20,
    todayNewRecovered: 12,
    todayOpenCases: 180,
    todayRecovered: 34,
  },
  {
    id: 13,
    country: 'Mali',
    todayConfirmed: 65,
    todayDeath: 2,
    todayNewConfirmed: 10,
    todayNewDeaths: 0,
    todayNewOpenCases: 6,
    todayNewRecovered: 4,
    todayOpenCases: 50,
    todayRecovered: 13,
  },
  {
    id: 14,
    country: 'Senegal',
    todayConfirmed: 130,
    todayDeath: 3,
    todayNewConfirmed: 20,
    todayNewDeaths: 0,
    todayNewOpenCases: 10,
    todayNewRecovered: 7,
    todayOpenCases: 110,
    todayRecovered: 17,
  },
  {
    id: 15,
    country: 'Ivory Coast',
    todayConfirmed: 85,
    todayDeath: 1,
    todayNewConfirmed: 15,
    todayNewDeaths: 0,
    todayNewOpenCases: 8,
    todayNewRecovered: 7,
    todayOpenCases: 70,
    todayRecovered: 14,
  },
  {
    id: 16,
    country: 'Cameroon',
    todayConfirmed: 110,
    todayDeath: 2,
    todayNewConfirmed: 25,
    todayNewDeaths: 0,
    todayNewOpenCases: 15,
    todayNewRecovered: 8,
    todayOpenCases: 95,
    todayRecovered: 13,
  },
  {
    id: 17,
    country: 'Angola',
    todayConfirmed: 45,
    todayDeath: 1,
    todayNewConfirmed: 7,
    todayNewDeaths: 0,
    todayNewOpenCases: 5,
    todayNewRecovered: 2,
    todayOpenCases: 38,
    todayRecovered: 6,
  },
  {
    id: 18,
    country: 'Zimbabwe',
    todayConfirmed: 75,
    todayDeath: 3,
    todayNewConfirmed: 12,
    todayNewDeaths: 1,
    todayNewOpenCases: 8,
    todayNewRecovered: 3,
    todayOpenCases: 60,
    todayRecovered: 12,
  },
  {
    id: 19,
    country: 'Namibia',
    todayConfirmed: 55,
    todayDeath: 1,
    todayNewConfirmed: 8,
    todayNewDeaths: 0,
    todayNewOpenCases: 6,
    todayNewRecovered: 2,
    todayOpenCases: 45,
    todayRecovered: 9,
  },
  {
    id: 20,
    country: 'Zambia',
    todayConfirmed: 95,
    todayDeath: 2,
    todayNewConfirmed: 18,
    todayNewDeaths: 0,
    todayNewOpenCases: 12,
    todayNewRecovered: 6,
    todayOpenCases: 80,
    todayRecovered: 13,
  },
  {
    id: 21,
    country: 'Botswana',
    todayConfirmed: 30,
    todayDeath: 0,
    todayNewConfirmed: 5,
    todayNewDeaths: 0,
    todayNewOpenCases: 3,
    todayNewRecovered: 2,
    todayOpenCases: 25,
    todayRecovered: 5,
  },
  {
    id: 1,
    country: 'Germany',
    todayConfirmed: 1500,
    todayDeath: 25,
    todayNewConfirmed: 200,
    todayNewDeaths: 3,
    todayNewOpenCases: 175,
    todayNewRecovered: 22,
    todayOpenCases: 1200,
    todayRecovered: 275,
  },
  {
    id: 2,
    country: 'France',
    todayConfirmed: 2000,
    todayDeath: 40,
    todayNewConfirmed: 250,
    todayNewDeaths: 5,
    todayNewOpenCases: 200,
    todayNewRecovered: 45,
    todayOpenCases: 1500,
    todayRecovered: 460,
  },
  {
    id: 3,
    country: 'Italy',
    todayConfirmed: 1800,
    todayDeath: 30,
    todayNewConfirmed: 190,
    todayNewDeaths: 2,
    todayNewOpenCases: 175,
    todayNewRecovered: 13,
    todayOpenCases: 1350,
    todayRecovered: 420,
  },
  {
    id: 4,
    country: 'Spain',
    todayConfirmed: 2200,
    todayDeath: 35,
    todayNewConfirmed: 260,
    todayNewDeaths: 4,
    todayNewOpenCases: 240,
    todayNewRecovered: 16,
    todayOpenCases: 1750,
    todayRecovered: 415,
  },
  {
    id: 5,
    country: 'United Kingdom',
    todayConfirmed: 1800,
    todayDeath: 20,
    todayNewConfirmed: 210,
    todayNewDeaths: 3,
    todayNewOpenCases: 180,
    todayNewRecovered: 27,
    todayOpenCases: 1250,
    todayRecovered: 530,
  },
  {
    id: 6,
    country: 'Russia',
    todayConfirmed: 2400,
    todayDeath: 50,
    todayNewConfirmed: 300,
    todayNewDeaths: 6,
    todayNewOpenCases: 270,
    todayNewRecovered: 24,
    todayOpenCases: 1800,
    todayRecovered: 550,
  },
  {
    id: 7,
    country: 'Poland',
    todayConfirmed: 1300,
    todayDeath: 15,
    todayNewConfirmed: 170,
    todayNewDeaths: 1,
    todayNewOpenCases: 155,
    todayNewRecovered: 14,
    todayOpenCases: 950,
    todayRecovered: 335,
  },
  {
    id: 8,
    country: 'Netherlands',
    todayConfirmed: 1000,
    todayDeath: 20,
    todayNewConfirmed: 130,
    todayNewDeaths: 2,
    todayNewOpenCases: 110,
    todayNewRecovered: 18,
    todayOpenCases: 720,
    todayRecovered: 260,
  },
  {
    id: 9,
    country: 'Ukraine',
    todayConfirmed: 1100,
    todayDeath: 25,
    todayNewConfirmed: 140,
    todayNewDeaths: 3,
    todayNewOpenCases: 120,
    todayNewRecovered: 17,
    todayOpenCases: 800,
    todayRecovered: 275,
  },
  {
    id: 10,
    country: 'Belgium',
    todayConfirmed: 900,
    todayDeath: 15,
    todayNewConfirmed: 120,
    todayNewDeaths: 1,
    todayNewOpenCases: 105,
    todayNewRecovered: 14,
    todayOpenCases: 650,
    todayRecovered: 235,
  },

  {
    id: 1,
    country: 'Sweden',
    todayConfirmed: 1200,
    todayDeath: 30,
    todayNewConfirmed: 180,
    todayNewDeaths: 2,
    todayNewOpenCases: 150,
    todayNewRecovered: 28,
    todayOpenCases: 900,
    todayRecovered: 270,
  },
  {
    id: 2,
    country: 'Switzerland',
    todayConfirmed: 800,
    todayDeath: 10,
    todayNewConfirmed: 90,
    todayNewDeaths: 1,
    todayNewOpenCases: 80,
    todayNewRecovered: 9,
    todayOpenCases: 540,
    todayRecovered: 250,
  },
  {
    id: 3,
    country: 'Austria',
    todayConfirmed: 700,
    todayDeath: 15,
    todayNewConfirmed: 80,
    todayNewDeaths: 1,
    todayNewOpenCases: 65,
    todayNewRecovered: 14,
    todayOpenCases: 480,
    todayRecovered: 205,
  },
  {
    id: 4,
    country: 'Portugal',
    todayConfirmed: 500,
    todayDeath: 10,
    todayNewConfirmed: 70,
    todayNewDeaths: 1,
    todayNewOpenCases: 60,
    todayNewRecovered: 9,
    todayOpenCases: 360,
    todayRecovered: 130,
  },
  {
    id: 5,
    country: 'Denmark',
    todayConfirmed: 400,
    todayDeath: 5,
    todayNewConfirmed: 50,
    todayNewDeaths: 1,
    todayNewOpenCases: 45,
    todayNewRecovered: 4,
    todayOpenCases: 280,
    todayRecovered: 115,
  },
  {
    id: 6,
    country: 'Norway',
    todayConfirmed: 300,
    todayDeath: 5,
    todayNewConfirmed: 40,
    todayNewDeaths: 1,
    todayNewOpenCases: 35,
    todayNewRecovered: 4,
    todayOpenCases: 190,
    todayRecovered: 105,
  },
  {
    id: 7,
    country: 'Czech Republic',
    todayConfirmed: 900,
    todayDeath: 20,
    todayNewConfirmed: 100,
    todayNewDeaths: 2,
    todayNewOpenCases: 90,
    todayNewRecovered: 8,
    todayOpenCases: 590,
    todayRecovered: 290,
  },
  {
    id: 8,
    country: 'Romania',
    todayConfirmed: 600,
    todayDeath: 15,
    todayNewConfirmed: 80,
    todayNewDeaths: 1,
    todayNewOpenCases: 70,
    todayNewRecovered: 9,
    todayOpenCases: 390,
    todayRecovered: 195,
  },
  {
    id: 9,
    country: 'Hungary',
    todayConfirmed: 400,
    todayDeath: 10,
    todayNewConfirmed: 60,
    todayNewDeaths: 1,
    todayNewOpenCases: 50,
    todayNewRecovered: 9,
    todayOpenCases: 270,
    todayRecovered: 120,
  },
  {
    id: 10,
    country: 'Greece',
    todayConfirmed: 300,
    todayDeath: 5,
    todayNewConfirmed: 40,
    todayNewDeaths: 1,
    todayNewOpenCases: 35,
    todayNewRecovered: 4,
    todayOpenCases: 200,
    todayRecovered: 95,
  },
  {
    id: 11,
    country: 'Netherlands',
    todayConfirmed: 1400,
    todayDeath: 25,
    todayNewConfirmed: 170,
    todayNewDeaths: 2,
    todayNewOpenCases: 140,
    todayNewRecovered: 28,
    todayOpenCases: 1000,
    todayRecovered: 375,
  },
  {
    id: 12,
    country: 'Belgium',
    todayConfirmed: 1200,
    todayDeath: 20,
    todayNewConfirmed: 150,
    todayNewDeaths: 2,
    todayNewOpenCases: 120,
    todayNewRecovered: 28,
    todayOpenCases: 800,
    todayRecovered: 380,
  },
  {
    id: 13,
    country: 'Poland',
    todayConfirmed: 1000,
    todayDeath: 15,
    todayNewConfirmed: 120,
    todayNewDeaths: 1,
    todayNewOpenCases: 100,
    todayNewRecovered: 19,
    todayOpenCases: 670,
    todayRecovered: 315,
  },
  {
    id: 14,
    country: 'Ireland',
    todayConfirmed: 700,
    todayDeath: 10,
    todayNewConfirmed: 80,
    todayNewDeaths: 1,
    todayNewOpenCases: 70,
    todayNewRecovered: 9,
    todayOpenCases: 460,
    todayRecovered: 230,
  },
  {
    id: 15,
    country: 'Finland',
    todayConfirmed: 400,
    todayDeath: 5,
    todayNewConfirmed: 50,
    todayNewDeaths: 1,
    todayNewOpenCases: 45,
    todayNewRecovered: 4,
    todayOpenCases: 270,
    todayRecovered: 125,
  },
  {
    id: 16,
    country: 'Croatia',
    todayConfirmed: 300,
    todayDeath: 5,
    todayNewConfirmed: 40,
    todayNewDeaths: 1,
    todayNewOpenCases: 35,
    todayNewRecovered: 4,
    todayOpenCases: 190,
    todayRecovered: 105,
  },
  {
    id: 17,
    country: 'Slovakia',
    todayConfirmed: 200,
    todayDeath: 5,
    todayNewConfirmed: 30,
    todayNewDeaths: 1,
    todayNewOpenCases: 25,
    todayNewRecovered: 4,
    todayOpenCases: 130,
    todayRecovered: 65,
  },
  {
    id: 18,
    country: 'Bulgaria',
    todayConfirmed: 200,
    todayDeath: 5,
    todayNewConfirmed: 30,
    todayNewDeaths: 1,
    todayNewOpenCases: 25,
    todayNewRecovered: 4,
    todayOpenCases: 130,
    todayRecovered: 65,
  },
  {
    id: 19,
    country: 'Serbia',
    todayConfirmed: 400,
    todayDeath: 10,
    todayNewConfirmed: 50,
    todayNewDeaths: 1,
    todayNewOpenCases: 45,
    todayNewRecovered: 4,
    todayOpenCases: 270,
    todayRecovered: 125,
  },
  {
    id: 20,
    country: 'Switzerland',
    todayConfirmed: 300,
    todayDeath: 5,
    todayNewConfirmed: 40,
    todayNewDeaths: 1,
    todayNewOpenCases: 35,
    todayNewRecovered: 4,
    todayOpenCases: 190,
    todayRecovered: 105,
  },

  {
    id: 1,
    country: 'United States',
    todayConfirmed: 800000,
    todayDeath: 10000,
    todayNewConfirmed: 90000,
    todayNewDeaths: 1000,
    todayNewOpenCases: 80000,
    todayNewRecovered: 10000,
    todayOpenCases: 400000,
    todayRecovered: 400000,
  },
  {
    id: 2,
    country: 'Canada',
    todayConfirmed: 50000,
    todayDeath: 500,
    todayNewConfirmed: 5000,
    todayNewDeaths: 50,
    todayNewOpenCases: 4000,
    todayNewRecovered: 450,
    todayOpenCases: 20000,
    todayRecovered: 29000,
  },
  {
    id: 3,
    country: 'Mexico',
    todayConfirmed: 100000,
    todayDeath: 5000,
    todayNewConfirmed: 15000,
    todayNewDeaths: 1000,
    todayNewOpenCases: 13000,
    todayNewRecovered: 2000,
    todayOpenCases: 70000,
    todayRecovered: 25000,
  },
  {
    id: 4,
    country: 'Cuba',
    todayConfirmed: 2000,
    todayDeath: 50,
    todayNewConfirmed: 300,
    todayNewDeaths: 10,
    todayNewOpenCases: 250,
    todayNewRecovered: 40,
    todayOpenCases: 1300,
    todayRecovered: 650,
  },
  {
    id: 5,
    country: 'Jamaica',
    todayConfirmed: 500,
    todayDeath: 10,
    todayNewConfirmed: 50,
    todayNewDeaths: 2,
    todayNewOpenCases: 40,
    todayNewRecovered: 8,
    todayOpenCases: 300,
    todayRecovered: 190,
  },
  {
    id: 1,
    country: 'Brazil',
    todayConfirmed: 1000000,
    todayDeath: 20000,
    todayNewConfirmed: 110000,
    todayNewDeaths: 1500,
    todayNewOpenCases: 95000,
    todayNewRecovered: 14000,
    todayOpenCases: 500000,
    todayRecovered: 470000,
  },
  {
    id: 2,
    country: 'Argentina',
    todayConfirmed: 200000,
    todayDeath: 4000,
    todayNewConfirmed: 18000,
    todayNewDeaths: 300,
    todayNewOpenCases: 15500,
    todayNewRecovered: 2200,
    todayOpenCases: 75000,
    todayRecovered: 120000,
  },
  {
    id: 3,
    country: 'Colombia',
    todayConfirmed: 80000,
    todayDeath: 1500,
    todayNewConfirmed: 7500,
    todayNewDeaths: 120,
    todayNewOpenCases: 6200,
    todayNewRecovered: 1180,
    todayOpenCases: 48000,
    todayRecovered: 31000,
  },
  {
    id: 4,
    country: 'Peru',
    todayConfirmed: 50000,
    todayDeath: 2000,
    todayNewConfirmed: 4500,
    todayNewDeaths: 90,
    todayNewOpenCases: 4000,
    todayNewRecovered: 410,
    todayOpenCases: 19000,
    todayRecovered: 29000,
  },
  {
    id: 5,
    country: 'Chile',
    todayConfirmed: 30000,
    todayDeath: 500,
    todayNewConfirmed: 3500,
    todayNewDeaths: 60,
    todayNewOpenCases: 2800,
    todayNewRecovered: 640,
    todayOpenCases: 11000,
    todayRecovered: 18000,
  },
  {
    id: 6,
    country: 'Venezuela',
    todayConfirmed: 5000,
    todayDeath: 100,
    todayNewConfirmed: 350,
    todayNewDeaths: 8,
    todayNewOpenCases: 250,
    todayNewRecovered: 92,
    todayOpenCases: 1600,
    todayRecovered: 3300,
  },
  {
    id: 7,
    country: 'Ecuador',
    todayConfirmed: 25000,
    todayDeath: 1000,
    todayNewConfirmed: 2800,
    todayNewDeaths: 45,
    todayNewOpenCases: 2000,
    todayNewRecovered: 755,
    todayOpenCases: 8500,
    todayRecovered: 15000,
  },
  {
    id: 8,
    country: 'Bolivia',
    todayConfirmed: 12000,
    todayDeath: 400,
    todayNewConfirmed: 1250,
    todayNewDeaths: 27,
    todayNewOpenCases: 1000,
    todayNewRecovered: 223,
    todayOpenCases: 4300,
    todayRecovered: 7200,
  },
  {
    id: 9,
    country: 'Paraguay',
    todayConfirmed: 6000,
    todayDeath: 120,
    todayNewConfirmed: 720,
    todayNewDeaths: 10,
    todayNewOpenCases: 550,
    todayNewRecovered: 160,
    todayOpenCases: 2000,
    todayRecovered: 3800,
  },
  {
    id: 1,
    country: 'Australia',
    todayConfirmed: 1000,
    todayDeath: 10,
    todayNewConfirmed: 120,
    todayNewDeaths: 1,
    todayNewOpenCases: 100,
    todayNewRecovered: 19,
    todayOpenCases: 400,
    todayRecovered: 590,
  },
  {
    id: 1,
    country: 'India',
    todayConfirmed: 300000,
    todayDeath: 3000,
    todayNewConfirmed: 35000,
    todayNewDeaths: 450,
    todayNewOpenCases: 29000,
    todayNewRecovered: 8000,
    todayOpenCases: 160000,
    todayRecovered: 136000,
  },
  {
    id: 2,
    country: 'Indonesia',
    todayConfirmed: 50000,
    todayDeath: 2000,
    todayNewConfirmed: 4200,
    todayNewDeaths: 65,
    todayNewOpenCases: 3500,
    todayNewRecovered: 635,
    todayOpenCases: 27000,
    todayRecovered: 21000,
  },
  {
    id: 3,
    country: 'Pakistan',
    todayConfirmed: 20000,
    todayDeath: 400,
    todayNewConfirmed: 1800,
    todayNewDeaths: 25,
    todayNewOpenCases: 1500,
    todayNewRecovered: 275,
    todayOpenCases: 8000,
    todayRecovered: 12000,
  },
  {
    id: 4,
    country: 'Bangladesh',
    todayConfirmed: 15000,
    todayDeath: 300,
    todayNewConfirmed: 1700,
    todayNewDeaths: 22,
    todayNewOpenCases: 1400,
    todayNewRecovered: 278,
    todayOpenCases: 6000,
    todayRecovered: 9000,
  },
  {
    id: 5,
    country: 'Iran',
    todayConfirmed: 20000,
    todayDeath: 1000,
    todayNewConfirmed: 2400,
    todayNewDeaths: 50,
    todayNewOpenCases: 1900,
    todayNewRecovered: 450,
    todayOpenCases: 15000,
    todayRecovered: 45000,
  },
  {
    id: 6,
    country: 'Turkey',
    todayConfirmed: 30000,
    todayDeath: 500,
    todayNewConfirmed: 2900,
    todayNewDeaths: 60,
    todayNewOpenCases: 2200,
    todayNewRecovered: 640,
    todayOpenCases: 21000,
    todayRecovered: 81000,
  },
  {
    id: 7,
    country: 'Iraq',
    todayConfirmed: 15000,
    todayDeath: 300,
    todayNewConfirmed: 1600,
    todayNewDeaths: 20,
    todayNewOpenCases: 1300,
    todayNewRecovered: 275,
    todayOpenCases: 6000,
    todayRecovered: 8500,
  },
  {
    id: 8,
    country: 'Philippines',
    todayConfirmed: 10000,
    todayDeath: 200,
    todayNewConfirmed: 1100,
    todayNewDeaths: 17,
    todayNewOpenCases: 900,
    todayNewRecovered: 183,
    todayOpenCases: 4000,
    todayRecovered: 5800,
  },
  {
    id: 9,
    country: 'Saudi Arabia',
    todayConfirmed: 8000,
    todayDeath: 100,
    todayNewConfirmed: 950,
    todayNewDeaths: 12,
    todayNewOpenCases: 750,
    todayNewRecovered: 188,
    todayOpenCases: 2700,
    todayRecovered: 5000,
  },
  {
    id: 1,
    country: 'India',
    todayConfirmed: 300000,
    todayDeath: 3000,
    todayNewConfirmed: 35000,
    todayNewDeaths: 450,
    todayNewOpenCases: 29000,
    todayNewRecovered: 8000,
    todayOpenCases: 160000,
    todayRecovered: 136000,
  },
  {
    id: 2,
    country: 'Indonesia',
    todayConfirmed: 50000,
    todayDeath: 2000,
    todayNewConfirmed: 4200,
    todayNewDeaths: 65,
    todayNewOpenCases: 3500,
    todayNewRecovered: 635,
    todayOpenCases: 27000,
    todayRecovered: 21000,
  },
  {
    id: 3,
    country: 'Pakistan',
    todayConfirmed: 20000,
    todayDeath: 400,
    todayNewConfirmed: 1800,
    todayNewDeaths: 25,
    todayNewOpenCases: 1500,
    todayNewRecovered: 275,
    todayOpenCases: 8000,
    todayRecovered: 12000,
  },
  {
    id: 4,
    country: 'Bangladesh',
    todayConfirmed: 15000,
    todayDeath: 300,
    todayNewConfirmed: 1700,
    todayNewDeaths: 22,
    todayNewOpenCases: 1400,
    todayNewRecovered: 278,
    todayOpenCases: 6000,
    todayRecovered: 9000,
  },
  {
    id: 5,
    country: 'Iran',
    todayConfirmed: 20000,
    todayDeath: 1000,
    todayNewConfirmed: 2400,
    todayNewDeaths: 50,
    todayNewOpenCases: 1900,
    todayNewRecovered: 450,
    todayOpenCases: 15000,
    todayRecovered: 45000,
  },
  {
    id: 6,
    country: 'Turkey',
    todayConfirmed: 30000,
    todayDeath: 500,
    todayNewConfirmed: 2900,
    todayNewDeaths: 60,
    todayNewOpenCases: 2200,
    todayNewRecovered: 640,
    todayOpenCases: 21000,
    todayRecovered: 81000,
  },
  {
    id: 7,
    country: 'Iraq',
    todayConfirmed: 15000,
    todayDeath: 300,
    todayNewConfirmed: 1600,
    todayNewDeaths: 20,
    todayNewOpenCases: 1300,
    todayNewRecovered: 275,
    todayOpenCases: 6000,
    todayRecovered: 8500,
  },
  {
    id: 8,
    country: 'Philippines',
    todayConfirmed: 10000,
    todayDeath: 200,
    todayNewConfirmed: 1100,
    todayNewDeaths: 17,
    todayNewOpenCases: 900,
    todayNewRecovered: 183,
    todayOpenCases: 4000,
    todayRecovered: 5800,
  },
  {
    id: 9,
    country: 'Saudi Arabia',
    todayConfirmed: 8000,
    todayDeath: 100,
    todayNewConfirmed: 950,
    todayNewDeaths: 12,
    todayNewOpenCases: 750,
    todayNewRecovered: 188,
    todayOpenCases: 2700,
    todayRecovered: 5000,
  },
  {
    id: 19,
    country: 'Cambodia',
    todayConfirmed: 100,
    todayDeath: 0,
    todayNewConfirmed: 10,
    todayNewDeaths: 0,
    todayNewOpenCases: 10,
    todayNewRecovered: 0,
    todayOpenCases: 50,
    todayRecovered: 50,
  },
  {
    id: 20,
    country: 'Uzbekistan',
    todayConfirmed: 800,
    todayDeath: 7,
    todayNewConfirmed: 90,
    todayNewDeaths: 1,
    todayNewOpenCases: 80,
    todayNewRecovered: 9,
    todayOpenCases: 280,
    todayRecovered: 513,
  },
];

export default covidData;
